<form name="organizationConfigForm" #f="ngForm" (ngSubmit)="onSubmit(f)">
    <div class="row">
        <div class="col-md-6 mb-3">
            <label for="organization" class="form-label">Ente</label>
            <input type="text" class="form-control" id="organization" name="organization" ngModel
                [(ngModel)]="organizationConfig.organization" required />
        </div>
        <div class="col-md-6 mb-3">
            <label for="logo" class="form-label">Logo</label>
            <input class="form-control" type="file" id="logo" name="logo" accept="image/png"
                (change)="onLogoSelected($event)" />
            <div *ngIf="logoPreview" class="mt-2">
                <img [src]="logoPreview" alt="Logo" class="logo-preview" />
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-6 mb-3">
            <label for="commandName" class="form-label">Nome comando</label>
            <input type="text" class="form-control" id="commandName" name="commandName" ngModel
                [(ngModel)]="organizationConfig.commandName" required />
        </div>
        <div class="col-md-6 mb-3">
            <label for="commandPec" class="form-label">PEC comando</label>
            <input type="text" class="form-control" id="commandPec" name="commandPec" ngModel
                [(ngModel)]="organizationConfig.commandPec" required />
        </div>
    </div>
    <div class="row">
        <div class="col-md-6 mb-3">
            <label for="commandPhone" class="form-label">Telefono comando</label>
            <input type="text" class="form-control" id="commandPhone" name="commandPhone" ngModel
                [(ngModel)]="organizationConfig.commandPhone" required />
        </div>
        <div class="col-md-6 mb-3">
            <label for="commandFax" class="form-label">Fax comando</label>
            <input type="text" class="form-control" id="commandFax" name="commandFax" ngModel
                [(ngModel)]="organizationConfig.commandFax" required />
        </div>
    </div>
    <div class="row">
        <div class="col-md-6 mb-3">
            <label for="commandAddress" class="form-label">Indirizzo comando</label>
            <input type="text" class="form-control" id="commandAddress" name="commandAddress" ngModel
                [(ngModel)]="organizationConfig.commandAddress" required />
        </div>
        <div class="col-md-6 mb-3">
            <label for="commandProvince" class="form-label">Provincia comando</label>
            <input type="text" class="form-control" id="commandProvince" name="commandProvince" ngModel
                [(ngModel)]="organizationConfig.commandProvince" required />
        </div>
    </div>
    <div class="row">
        <div class="col-md-6 mb-3">
            <label for="commandCap" class="form-label">CAP comando</label>
            <input type="text" class="form-control" id="commandCap" name="commandCap" ngModel
                [(ngModel)]="organizationConfig.commandCap" required />
        </div>
        <div class="col-md-6 mb-3">
            <label for="nameDPO" class="form-label">Nome DPO</label>
            <input type="text" class="form-control" id="nameDPO" name="nameDPO" ngModel
                [(ngModel)]="organizationConfig.nameDPO" required />
        </div>
    </div>
    <div class="row">
        <div class="col-md-6 mb-3">
            <label for="customerReception" class="form-label">Ricevimento pubblico</label>
            <input type="text" class="form-control" id="customerReception" name="customerReception" ngModel
                [(ngModel)]="organizationConfig.customerReception" required />
        </div>
        <div class="col-md-6 mb-3">
            <label for="paymentMethod" class="form-label">Metodo di pagamento</label>
            <input type="text" class="form-control" id="paymentMethod" name="paymentMethod" ngModel
                [(ngModel)]="organizationConfig.paymentMethod" required />
        </div>
    </div>
    <div class="row">
        <div class="col-md-6 mb-3">
            <label for="accountNumber" class="form-label">Numero conto</label>
            <input type="text" class="form-control" id="accountNumber" name="accountNumber"
                [(ngModel)]="organizationConfig.accountNumber" />
        </div>
        <div class="col-md-6 mb-3">
            <label for="accountOwner" class="form-label">Intestatario conto</label>
            <input type="text" class="form-control" id="accountOwner" name="accountOwner"
                [(ngModel)]="organizationConfig.accountOwner" />
        </div>
    </div>

    <div class="d-flex justify-content-end  align-items-center mt-2 gap-2">
        <!-- <ng-template [hasPermission]="['ORGANIZATION_CONFIG_DELETE', 'ORGANIZATION_CONFIG_ALL','SAFESTREET_ADMIN']">
            <button type="button" (click)="confirmDelete()" class="btn btn-danger">
                Elimina
            </button>
        </ng-template> -->
        <ng-template [hasPermission]="['ORGANIZATION_CONFIG_CREATE', 'ORGANIZATION_CONFIG_UPDATE', 'ORGANIZATION_CONFIG_ALL','SAFESTREET_ADMIN']">
            <button type="submit" class="btn btn-primary">
                Salva
            </button>
        </ng-template>
    </div>
</form>
<app-confirm-alert [confirmationMessage]="confirmationMessage"
    [showConfirmationModal]="showConfirmationModal" (modalConfirm)="delete()" (modalCancel)="cancelDelete()">
</app-confirm-alert>
